import { Spin } from 'antd';
import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
`;

export const LoadingIndicator = styled(Spin)`
  font-size: 24px;
`;

export const LoadingMessage = styled.p`
  font-size: 18px;
  color: var(--bg-button-default-color);
  margin-top: 16px;
  margin-left: 20px;
`;
